<template>
  <div class="meetingsPowerBiStep">
    <!-- <vs-popup fullscreen :active.sync="previewPopupActive" title="Report" id="powerBiPreviewPopup">
      <PowerbiReport :reportId="step.reportId" :showLoading="true" />
    </vs-popup> -->
    <div class="powerBiGridWrapper">
      <div>
        <vx-card class="h-full overflowDefinition">
          <!-- <vs-row vs-justify="space-between" class="mb-4">
            <vs-button class="px-3 py-2 opacity-0 pointer-events-none">
              <feather-icon icon="XIcon" svgClasses="w-5 h-5" />
            </vs-button>
            <h3>Report</h3>

            <vs-button @click="fullscreen" type="flat" class="px-3 py-2">
              <feather-icon icon="Maximize2Icon" svgClasses="w-5 h-5" />
            </vs-button>
          </vs-row> -->
          <div class="relative reportStepWrapper flex justify-center">
            <PowerbiReport
              class="w-full"
              :venueFilter="step.applyVenueFilter"
              :venueFilterColumn="step.venueFilterColumn"
              :venueFilterTable="step.venueFilterTable"
              :workspaceId="step.workspaceId"
              :reportId="step.reportId"
              :filterVenue="meetingInstance.venueId"
              :showLoading="false"
              :showNavbar="false"
              ref="powerBiReport"
            />
          </div>
        </vx-card>
      </div>
      <div class="pl-4">
        <vx-card class="h-full overflowDefinition">
          <!--   <vs-row vs-justify="center" class="mb-4">
            <h3>Questions</h3>
          </vs-row> -->
          <Question
            v-for="question in step.questions"
            :key="question.id"
            :question="question"
            :isEditable="meetingInstance.isEditable"
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Question from "../MeetingQuestion.vue";
import PowerbiReport from "@/components/PowerbiReport";
export default {
  props: ["step", "meetingInstance"],
  components: { Question, PowerbiReport },
  data() {
    return {
      // previewPopupActive: false,
    };
  },
  mounted() {},
  methods: {
    fullscreen() {
      console.log("calling fullscreen start", this.$refs);
      this.$refs.powerBiReport.report.fullscreen();
    },
  },
};
</script>

<style lang="scss">
.meetingsPowerBiStep {
  .overflowDefinition {
    max-height: 70vh;
    overflow-y: auto;
  }

  .powerBiGridWrapper {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-auto-columns: 1fr;
  }

  #powerBiPreviewPopup {
    .vs-popup--content {
      height: 100%;
    }
  }

  $maxWidth: 900px;
  .reportStepWrapper {
    display: flex;
    justify-content: center;

    #powerbi-wrapper {
      // aspect-ratio: 4/3;
      max-width: $maxWidth;

      #report-wrapper {
        margin: 0 !important;
        padding-top: min(75%, $maxWidth * 0.75);
      }
    }
  }
}
</style>

